<div class="profile-panel" data-testid="profile-panel">
    <app-profile class="ev-card" [loadingMap]="loadingMap ?? null" [dropdownVisible]="dropdownVisible()"
        (profileToggleRequested)="onProfileToggleRequested()"></app-profile>
    <app-profile-dropdown class="ev-card" ownerClass="profile-panel" [loadingMap]="loadingMap ?? ''"
        [dropdownVisible]="dropdownVisible()"
        (closeRequested)="dropdownVisible.set(false)"
        [class.dropdown-open]="dropdownVisible()"></app-profile-dropdown>
</div>